import { ThemeNames } from '../themes';
import ThemeProvider from '../ThemeProvider';
import styled, { css, StyledComponents, ThemeConsumer } from '../ThemeStyle';
import Theme from '../types/theme';
import ThemedProps from '../types/themeProps';

export type { Theme, ThemeNames, ThemedProps };
export { css, StyledComponents, ThemeConsumer, ThemeProvider };

export default styled;
